import { Box, BoxProps, Breakpoint, useTheme } from "@mui/material";
import { layoutClasses } from "app/layout/settings";

type AuthLayoutContentProps = BoxProps & {
  layoutQuery: Breakpoint;
};

export function AuthLayoutContent({
  children,
  layoutQuery,
  sx,
  ...other
}: AuthLayoutContentProps) {
  const theme = useTheme();

  const renderContent = (
    <Box
      sx={{
        bgcolor: "background.default",
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        maxWidth: "var(--layout-auth-content-width)",
        px: 3,
        py: 5,
        width: 1,
      }}
    >
      {children}
    </Box>
  );

  return (
    <Box
      className={layoutClasses.main}
      component="main"
      sx={{
        alignItems: "center",
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        p: theme.spacing(3, 2, 10, 2),
        [theme.breakpoints.up(layoutQuery)]: {
          justifyContent: "center",
          p: theme.spacing(10, 0, 10, 0),
        },
        ...sx,
      }}
      {...other}
    >
      {renderContent}
    </Box>
  );
}
